import store from "store"
import { identity } from "@/utils/functions"

export default {
	install(Vue, {
		config = identity,
	} = {}){
		config(store);

		[Vue, Vue.prototype]
		.forEach(target => {
			Object.defineProperties(target, {
				$localStorage: {
					get(){
						return store;
					},
				},
			});
		});
	},
}
